import React, { Suspense, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { filterOverview } from "../utils/todo-utils";
import { getFilterState } from "../functions/filterState/filterState";
import OverviewComponent from "../components/overview/OverviewComponent";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getLatestTaskList } from "../redux/actions/Firebase/getLatestTaskListAction";
import { getSubscription, askForNotificationPermission } from "../functions/notifications/notificationFunctions";
import { Capacitor } from "@capacitor/core"
import { getItem, removeItem } from "../utils/storageHelper";

function Homepage() {
    
    //const location = useLocation();
    //const feature = location.pathname.substring(1);
    const feature = "Overview";
    const filterStateName = getFilterState(feature) ?? "overviewFilterState" ;
    const dispatch = useDispatch();
    const projects = useSelector((state) => state.taskList.data);
    const filterState = useSelector(state => state[filterStateName]);
    const filteredProjects = filterOverview(projects, filterState, new Date());
    const currentlyDraggedProjectId = useSelector((state) => state.isDragging.currentlyDraggedProjectId);
    const zoomLevel = useSelector((state) => state.userSettings.zoomLevel);
    const navigate = useNavigate();
    const isProjectDragging = useSelector((state) => state.isDragging.isDragging);
    const [redirectUrl, setRedirectUrl] = useState(null);

    useEffect(() => {
        const loadRedirectUrl = async () => {
            try {
                const url = await getItem('redirectUrl');
                setRedirectUrl(url);
            } catch (error) {
                console.error('Failed to load redirect URL:', error);
            }
        };

        loadRedirectUrl();
    }, []);
    const { todoid } = useParams();
    useEffect(() => {
        const handleRedirect = async () => {
            if (redirectUrl) {
                await removeItem('redirectUrl'); 
                if (!todoid) {
                    navigate(redirectUrl);
                }
            }
        };

        handleRedirect();
    }, [navigate, redirectUrl]);

    useEffect(() => {
        const processData = async () => {
            try {
                const firebaseData = await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`); // ✅ Properly await

                if (firebaseData) {
                    if (!projects || projects.length === 0) {
                        dispatch(getLatestTaskList());
                    }
                    if (Capacitor.isNativePlatform()) {
                        askForNotificationPermission();
                    }
                    else if ('Notification' in window) {
                        if (Notification.permission === 'default') {
                            Notification.requestPermission().then((permission) => {
                                if (permission === 'granted') {
                                    getSubscription();
                                    console.log('User granted notifications');
                                } else {
                                    console.log('User denied notifications');
                                }
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Failed to load firebase data:', error);
            }
        };

        processData();
    }, []);
   
   
    return (
            <Suspense fallback={<LoadingScreen />}>
                {filteredProjects && <OverviewComponent
                    projects={filteredProjects.projects}
                    zoomLevel={zoomLevel}
                    isProjectDragging={isProjectDragging}
                    currentlyDraggedProjectId={currentlyDraggedProjectId}
                />}
            </Suspense>
    );
}

export default Homepage;
